import { DEFAULT_LOCALE, ENVIRONMENT_DOMAINS, REQUEST_TIMEOUT, ZENDESK_SUBDOMAINS, } from '../../constants';
import { Service } from '../../enums';
import { getDomainConfig } from '../../routes';
import { EnvironmentTypes } from '../../types';
import { DOMAIN_LOCALE, getEnvironment, getRegionFromHost, isCSR } from '../../utils/domain';
const { config } = require('../../../config');
export const getPensionBaseUrl = () => {
    const env = getEnvironment();
    switch (env) {
        case EnvironmentTypes.PRODUCTION:
            return 'https://www.weltsparen.de/pension/v1';
        case EnvironmentTypes.LOCAL:
            return 'http://localhost:8080/pension/v1';
        default:
            return 'https://www.staging-weltsparen.de/pension/v1';
    }
};
const getMicroserviceNamespaceBaseUrl = (name, region) => ({
    [Service.KEYCLOAK]: `https://auth-${region}-${name}.raisin-dev.network/auth/realms/global`,
    [Service.CAS]: `https://customer-administration-service-${region}-${name}.raisin-dev.network/v1/`,
    [Service.TAMS]: `https://tams-${region}-${name}.raisin-dev.network/v1/`,
    [Service.CPMS]: `https://cpms-${name}-${region}.raisin-dev.network/public/v1/`,
    [Service.KCI]: `https://kyc-connector-idnow-${region}-${name}.raisin-dev.network/api/v1/`,
    [Service.DDS]: `https://document-depot-${region}-${name}.raisin-dev.network/api/v2/`,
    [Service.CPS]: `https://investor-postbox-service-${region}-${name}.raisin-dev.network/api/v1`,
    [Service.KSS]: `https://kyc-status-service-${region}-${name}.raisin-dev.network/api/v1`,
    [Service.CTS]: `https://cts-${region}-${name}.raisin-dev.network/v1`,
});
const getOBSServiceBaseURL = () => isCSR() ? `${window.location.origin}/savingglobal/rest/open_api/v2` : '';
export const getZendeskServiceBaseUrl = (locale) => `https://${ZENDESK_SUBDOMAINS[locale]}.zendesk.com`;
const getIntegrationServiceUrl = (version = 'v1') => {
    var _a, _b;
    const hostEnvironment = ENVIRONMENT_DOMAINS[getEnvironment().toLowerCase()];
    if (version === 'v2')
        return `https://api2.${hostEnvironment}raisin.com/wjis/v2`;
    getEnvironment() === EnvironmentTypes.LOCAL && import('dotenv/config');
    const developmentLocale = process.env.REACT_APP_LOCALE || process.env.APP_LOCALE || 'en';
    const normalizedHostname = isCSR()
        ? (_a = window.location.hostname) === null || _a === void 0 ? void 0 : _a.replace(`www.${hostEnvironment}`, '')
        : '';
    const noneDevLocale = DOMAIN_LOCALE[normalizedHostname] || (isCSR() ? (_b = window.location.pathname) === null || _b === void 0 ? void 0 : _b.split('/')[1] : '');
    const locale = getEnvironment() === EnvironmentTypes.LOCAL || noneDevLocale === ''
        ? developmentLocale
        : noneDevLocale;
    const domainConfig = getDomainConfig(locale);
    return domainConfig
        ? `https://${domainConfig.integrationServiceDomainName}.${hostEnvironment}${domainConfig.integrationServicePath}`
        : '';
};
const getMicroserviceBaseURL = (service) => {
    var _a, _b, _c, _d;
    const environment = (_a = getEnvironment()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    const region = (_b = getRegionFromHost()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    const microservices = config.globals.microservices;
    const baseURL = (_d = (_c = microservices === null || microservices === void 0 ? void 0 : microservices[service]) === null || _c === void 0 ? void 0 : _c[region]) === null || _d === void 0 ? void 0 : _d[environment];
    if (baseURL)
        return baseURL;
    const namespaceUrl = getMicroserviceNamespaceBaseUrl(environment, region || 'deu')[service];
    if (environment && namespaceUrl)
        return namespaceUrl;
    return `https://internal-api.weltsparen.de/${service}/api/v1`;
};
export const getServiceBaseURL = (service, locale, version) => {
    switch (service) {
        case Service.IS:
        case Service.WJIS:
            return getIntegrationServiceUrl(version);
        case Service.OBS:
            return getOBSServiceBaseURL();
        case Service.Zendesk:
            return getZendeskServiceBaseUrl(locale || DEFAULT_LOCALE);
        case Service.PENSION:
            return getPensionBaseUrl();
        default:
            return getMicroserviceBaseURL(service);
    }
};
export const getMockedServiceBaseURL = (service) => {
    var _a;
    const microservices = config.globals.microservices;
    const baseURL = (_a = microservices === null || microservices === void 0 ? void 0 : microservices[service]) === null || _a === void 0 ? void 0 : _a.mock;
    if (baseURL)
        return baseURL;
    throw new Error(`Service [${service}] doesn't have a mock server configuration`);
};
export const getServiceTimeout = (service) => { var _a, _b; return (_b = (_a = config.globals.microservices) === null || _a === void 0 ? void 0 : _a[service]) === null || _b === void 0 ? void 0 : _b[REQUEST_TIMEOUT]; };
//# sourceMappingURL=services.js.map